'use strict';

const React = require('react');

//TODO: no way to relax no-unused-vars from es-lint rule
React.createClass({
    render() {
    }
});

const ChronologycStore = require('stores/ChronologycStore'),
    { t } = require('services/i18nextWrapper'),
    TankStore = require('stores/TankStore'),
    InventoryStore = require('stores/InventoryStore'),
    BeerStyleStore = require('stores/BeerStyleStore'),
    BrewhouseStore = require('stores/BrewhouseStore'),
    SessionStore = require('stores/SessionStore'),
    DashboardModalStore = require('stores/DashboardModalStore'),
    DashboardModalEl = require('components/DashboardModal/DashboardModalEl'),
    OrderStore = require('stores/OrderStore'),
    DashboardServiceCache = require('services/DashboardServiceCache'),
    { some, map, filter, includes, find } = require('lodash/collection'),
    { flatten, concat, last, findIndex, head } = require('lodash/array'),
    { cloneDeep } = require('lodash/lang'),
    { min } = require('lodash/math'),
    { assign, merge } = require('lodash/object'),
    sortBy = require('lodash/collection').sortBy,
    get = require('lodash/object').get,
    set = require('lodash/object').set,
    moment = require('moment'),
    NumberUtils = require('utils/NumberUtils'),
    DateUtils = require('utils/DateUtils'),
    OrderUtils = require('utils/OrderUtils'),
    ContentUtils = require('utils/ContentUtils'),
    DashboardModalUtils = require('components/DashboardModal/DashboardModalUtils'),
    DashboardModalTaskCollapsible = require('components/DashboardModal/DashboardModalTask/DashboardModalTaskCollapsible'),
    {
        getNonSelectedMenuItem,
        toTankMenuItems,
        toConcreteTask,
        getFermenterTank,
        getBriteTank,
        getStyleBeer,
        retrieveCustomTask,
        setTaskIds
    } = require('components/DashboardModal/DashboardModalUtils'),
    {
        FERMENTER_TYPE_TASK,
        PACKAGING_TYPE_TASK,
        SECONDARY_TASK,
        TYPE_TASK_PACKAGING,
        BREW_TASK,
        FILTRATION_TASK,
        PACKAGING_TASK,
        DATE_FORMAT,
        DATE_FORMAT_DISPLAY_COMBO_DAY,
        TYPE_TASK_FERMENTER,
        TYPE_TANK_FERMENTER,
        TYPE_TANK_BRITE_TANK,
        TYPE_TASK_BREWHOUSE,
        TYPE_TANK_BREW_HOUSE,
        TASK_NON_VISIBLE
    } = require('constants/AppConstants');

function _recalculateLayout(nextState) {
    const ordersFromRange = OrderUtils.getOrderByRange(nextState.brewDate, nextState.orderDate);
    const positionOrders = flatten(map(ordersFromRange, order => OrderUtils.convertOrderToPositions(order, ChronologycStore.getCurrentFrom(), null, true)));
    DashboardModalStore.setCurrentLayout(positionOrders);
    return nextState;
}

/**
 * Show the DashboardModalNew from the current clicked order.
 */
function openNewBrewOrder(preDefinedOrder) {
    DashboardModalEl.openNewOrder(preDefinedOrder);
}

/**
 * Show the DashboardModalChange from the existing clicked order.
 */
function openExistingBrewOrder(existingOrderInfo) {
    DashboardModalEl.openExistingBrewOrder(existingOrderInfo);
}

function onChangeTaskType(oldItemSelected, typeTask, dateTask, state, evt, itemSelected) {
    let newTasks = [];
    let nextState = {};

    const displayNameIcon = get(itemSelected.itemModel, 'id') === 1 ? 'no-icon' : (get(evt, 'text') || get(itemSelected, 'name') || get(itemSelected, 'text') || get(evt, 'target.value'));
    const currentIcon = DashboardServiceCache.findIconByDisplayName(displayNameIcon);

    // check if exist some existing task before
    // create a new one from scratch
    let newTask = getNewTask(dateTask, state, typeTask, itemSelected);

    if (ContentUtils.isEmptyArray(newTask.products)) {
        newTask.isNewProduct = true;
    }

    // clean older products
    newTask.products = [];

    // set the new task icon information
    newTask.displayName = displayNameIcon;
    newTask.name = get(currentIcon, 'name') || 'no-icon';

    if (currentIcon) {
        newTask.icon = currentIcon;
    } else {
        newTask.icon = undefined;
    }

    // We need to identify the default task such as brewDate or FiltrationDate or Packaging date
    newTask = assignTypeTask(state, newTask);

    const tankTypeInfo = ContentUtils.getTankTypeConfiguration(typeTask);
    const tasksFieldName = get(tankTypeInfo, 'tasksFieldName');

    // avoid duplications
    state.order[tasksFieldName] = filter(state.order[tasksFieldName], oldTask => oldTask.date !== newTask.date);
    // remove old task selected from given date
    if (oldItemSelected) {
        newTasks = filter(state.order[tasksFieldName], task => get(oldItemSelected, 'date') !== task.date);
    } else {
        newTasks = state.order[tasksFieldName];
    }
    newTask = head(InventoryStore.hydrateTaskWithProducts([newTask], get(state, 'styleBeerSelected.id')));
    newTasks.push(newTask);
    nextState = { [tasksFieldName]: newTasks };
    state.order[tasksFieldName] = ContentUtils.replaceByAttributes(state.order[tasksFieldName], newTask, 'date');

    state.order.totalBatchCost = BrewhouseStore.calculateCostByOrder(
        state.order,
        DashboardServiceCache.getVendorItems()
    );

    return assign(state, nextState);
}

function assignTypeTask(state, newTask) {
    if ((state.order && newTask.date === state.order.brewDate) || newTask.date === DateUtils.toDateText(state.brewDate)) {
        newTask.type = BREW_TASK;
    } else if ((state.order && newTask.date === state.order.filtrationDate) || newTask.date === DateUtils.toDateText(state.filtrationDate)) {
        newTask.type = FILTRATION_TASK;
    } else if ((state.order && newTask.date === state.order.orderDate) || newTask.date === DateUtils.toDateText(state.orderDate)) {
        newTask.type = PACKAGING_TASK;
    } else {
        newTask.type = SECONDARY_TASK;
    }

    return newTask;
}

function getNewTask(dateTask, state, typeTask, itemSelected) {
    let newTask = findExistingTask(dateTask, state, typeTask);
    if (newTask === undefined) {
        newTask = {
            date: dateTask,
            description: get(itemSelected, 'description') || '',
            label: get(itemSelected, 'label') || ''
        };
    }
    return newTask;
}

function onChangeBrewTurn(oldItemSelected, turnDate, fieldName, prevState, turnId, targetValue, itemSelected) {
    let nextState = cloneDeep(prevState);
    let oldBatchs = get(nextState, 'batchs');
    let batchNeedUpdate = cloneDeep(find(oldBatchs, batch => batch.date === turnDate && batch.turnId === turnId));
    let batchFiltered = cloneDeep(filter(oldBatchs, batch => !(batch.date === turnDate && batch.turnId === turnId))) || [];

    // set value into brew batch
    let batchUpdated = set(batchNeedUpdate, fieldName, targetValue);
    batchUpdated.task = get(DashboardServiceCache.getBrewhouseIcons(), `${(batchUpdated.payload - 1)}.name`);

    // hydrate with existing product (only for edit mode)
    batchUpdated = _completeWithOldProducts(batchUpdated, prevState, itemSelected);

    // clean old products
    batchNeedUpdate.products = [];

    // hydrate each task with products
    batchUpdated = head(InventoryStore.hydrateTaskWithProducts([batchUpdated], get(nextState, 'styleBeerSelected.id')));
    batchUpdated.tankType = 'BH';

    batchFiltered.push(batchUpdated);
    const sortedBatchs = DateUtils.sortListByDateField(batchFiltered, 'date');

    // update batch changed
    nextState = set(nextState, 'order.batchs', sortedBatchs);

    // the icon already selected
    if (itemSelected) {
        nextState.taskSelected = {
            type: get(itemSelected, 'itemModel.tankType'),
            name: get(itemSelected, 'itemModel.name')
        };
    } else {
        nextState.taskSelected = {
            type: get(batchUpdated, 'tankType'),
            name: get(batchUpdated, 'name'),
            task: get(batchUpdated, 'name')
        };
    }

    nextState.order.totalBatchCost = BrewhouseStore.calculateCostByOrder(
        nextState.order,
        DashboardServiceCache.getVendorItems()
    );

    return nextState;
}

function onChangeBrewTurnNew(oldItemSelected, turnDate, fieldName, prevState, turnId, targetValue, itemSelected) {
    let nextState = cloneDeep(prevState);
    let oldBatchs = get(nextState, prevState.singleTank ? 'order.batchs' : 'batchs');
    let batchNeedUpdate = cloneDeep(find(oldBatchs, batch => batch.date === turnDate && batch.turnId === turnId));
    let batchFiltered = cloneDeep(filter(oldBatchs, batch => !(batch.date === turnDate && batch.turnId === turnId))) || [];

    // set value into brew batch
    let batchUpdated = set(batchNeedUpdate, fieldName, targetValue);
    batchUpdated.task = get(DashboardServiceCache.getBrewhouseIcons(), `${(batchUpdated.payload - 1)}.name`);
    batchUpdated.name = batchUpdated.task;

    // hydrate with existing product (only for edit mode)
    batchUpdated = _completeWithOldProducts(batchUpdated, prevState, itemSelected);

    // clean old products
    batchNeedUpdate.products = [];

    // hydrate each task with products
    batchUpdated = head(InventoryStore.hydrateTaskWithProducts([batchUpdated], get(nextState, 'styleBeerSelected.id')));
    batchUpdated.tankType = 'BH';

    batchFiltered.push(batchUpdated);
    const sortedBatchs = DateUtils.sortListByDateField(batchFiltered, 'date');

    // update batch changed
    nextState = set(nextState, 'batchs', sortedBatchs);
    nextState = set(nextState, 'order.batchs', sortedBatchs);

    // the icon already selected
    if (itemSelected) {
        nextState.taskSelected = {
            type: get(itemSelected, 'itemModel.tankType'),
            name: get(itemSelected, 'itemModel.name'),
            task: get(itemSelected, 'itemModel.name')
        };
    } else {
        nextState.taskSelected = {
            type: get(batchUpdated, 'tankType'),
            name: get(batchUpdated, 'name'),
            task: get(batchUpdated, 'name')
        };
    }

    nextState.order.totalBatchCost = BrewhouseStore.calculateCostByOrder(
        nextState.order,
        DashboardServiceCache.getVendorItems()
    );

    return nextState;
}

function _completeWithOldProducts(taskDry, prevState) {
    if (prevState && prevState.order && taskDry) {
        const tankType = get(taskDry, 'sectionType');
        const taskFieldName = get(ContentUtils.getTankTypeConfiguration(tankType), 'tasksFieldName');
        const existingTasks = get(prevState.order, taskFieldName);
        const existingTask = find(existingTasks, task => task.date === taskDry.date);
        const haveExistingTask = !!existingTask;

        if (haveExistingTask) {
            taskDry.products = existingTask.products;
        }
    }
    return taskDry;
}

function onChangePackagingDate(oldState, orderDate, isBHAllowed, nonForceUpdate) {
    let nextState = cloneDeep(oldState) || {};

    nextState.orderDate = orderDate;

    // Loads menu items and set menu items properly depend of the sate context.
    nextState = _recalculateLayout(nextState);
    nextState = _recalculateTasks(nextState);
    nextState = _initMenuItems(nextState);
    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);  // update brewhouse because in getNewModalState should force update when click an empty cell on packaging side

    if (!nonForceUpdate) {
        nextState.shouldNeedValidate = true;
    }

    return nextState;
}

function onChangeFiltrationDate(oldState, filtrationDate, isBHAllowed, nonForceUpdate) {
    let nextState = cloneDeep(oldState) || {};

    nextState.filtrationDate = filtrationDate;

    nextState = _recalculateTasks(nextState);
    nextState = _initMenuItems(nextState);

    if (!nonForceUpdate) {
        nextState.shouldNeedValidate = true;
    }

    return nextState;
}

function onChangeBriteTank(oldState, menuItem, isBHAllowed) {
    let nextState = cloneDeep(oldState) || {};

    nextState.briteTankTextColor = 'inherit';
    nextState.briteTankSelected = menuItem;
    nextState.briteTankSelectedIndex = get(menuItem, 'payload');
    nextState.shouldNeedValidate = true;

    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);

    return nextState;
}

function onChangeFermenterTank(oldState, menuItem, isBHAllowed) {
    let nextState = cloneDeep(oldState) || {};
    nextState.fermenterTankTextColor = 'inherit';
    nextState.fermenterTankSelected = menuItem;
    nextState.fermenterTankSelectedIndex = get(menuItem, 'payload');
    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);
    nextState.shouldNeedValidate = true;
    return nextState;
}

/**
 * Given information about the order and type tank that will want to create a New Order, retrieve the state
 * should be have the modal from that request, taking care about kind of tanks an some other stuffs
 * (Fermenter, Packaging or BrewHouse side).
 *
 * @param preDefinedOrder
 * @returns {Object}
 */
function getNewModalState(preDefinedOrder, isBHAllowed) {
    let nextState = _getInitialState(preDefinedOrder, isBHAllowed);
    nextState = _initMenuItems(nextState);
    nextState = _setTankMenuItemClickedFromDashboard(nextState, get(preDefinedOrder, 'tankSelected'));

    if (!isBHAllowed) {
        // enter here means that toggle brewhouse is off
        nextState = BrewhouseStore.cleanBrewhouse(nextState);
    }

    nextState = set(nextState, 'order.id', ContentUtils.getRandomId());
    nextState = _someProductAlreadyConfirmed(nextState);

    return nextState;
}

function findExistingTask(date, state, typeTask) {
    let tasks;
    if (typeTask === TYPE_TASK_FERMENTER) {
        tasks = get(state, 'fermenterTasks');
    } else if (typeTask === TYPE_TASK_PACKAGING) {
        tasks = get(state, 'packagingTasks');
    }

    return find(tasks, task => get(task, 'date') === date);
}

function _recalculateTasks(nextState) {

    if (get(nextState, 'fermenterTasks.length') > 0) {
        nextState.fermenterTasks = _recalculeteDateTask(nextState.fermenterTasks, nextState.brewDate, nextState.filtrationDate);
        nextState.order.fermenterTasks = nextState.fermenterTasks;
    }


    if (get(nextState, 'packagingTasks.length') > 0) {
        nextState.packagingTasks = _recalculeteDateTask(nextState.packagingTasks, nextState.filtrationDate, nextState.orderDate);
        nextState.order.packagingTasks = nextState.packagingTasks;
    }

    return nextState;
}

function _getInitialState(preDefinedOrder) {
    let nextState = {};
    DashboardModalStore.setCurrentLayout(null);

    // all toggles are open
    nextState.isBHAllowed = true;
    nextState.isFVAllowed = true;
    nextState.isBTAllowed = true;

    nextState.isNewModal = true;
    nextState.isSingle = false;
    nextState = set(nextState, 'order.batchs', []); // add empty batchs to allow calcualte the batch needed
    nextState = set(nextState, 'batchs', []); // add empty batchs to allow calcualte the batch needed
    nextState.dataClicked = '';
    nextState.orderVolume = ContentUtils.getNumber(get(preDefinedOrder, 'tankSelected.volume'));
    nextState.orderVolumePristine = ContentUtils.getNumber(get(preDefinedOrder, 'tankSelected.volume'));
    nextState.tankTypeClicked = preDefinedOrder.tankTypeClicked;

    if (get(preDefinedOrder, 'tankSelected.type', get(preDefinedOrder, 'tankTypeClicked')) === 'FV') {
        nextState.isFermenterTankClicked = true;
        nextState.brewDate = preDefinedOrder.date;

    } else if (get(preDefinedOrder, 'tankSelected.type', get(preDefinedOrder, 'tankTypeClicked')) === 'BT') {
        nextState.isFermenterTankClicked = false;
        nextState.orderDate = preDefinedOrder.date;
    } else if (get(preDefinedOrder, 'tankTypeClicked') === 'BH') {
        // enter here means that was clicked the brewhouse section and by default is like
        // was clicked the first column available in fermenting section
        nextState.isFermenterTankClicked = true;
        nextState.brewDate = preDefinedOrder.date;
    }

    nextState.commentOrder = '';
    nextState.isSuggested = false;
    nextState.isVolumeAlreadySuggested = true;
    nextState.shouldNeedValidate = true;
    nextState.batchNumber = preDefinedOrder.batchNumber;
    nextState.styleBeerMessageError = nextState.styleBeerSelectedIndex ? '' : t('dashboard_modal_general_beer_style_inline_error');
    nextState.styleBeerSelectedIndex = null;
    nextState.styleBeerSelected = null;

    return nextState;
}

function _setTankMenuItemClickedFromDashboard(nextState, tankClicked) {
    if (nextState.isFermenterTankClicked) {
        const fermenterTankSelected = DashboardModalUtils.getFermenterTank(nextState.fermenterTankMenuItems, { fermenterTank: tankClicked });
        nextState.fermenterTankSelected = fermenterTankSelected.item;
        nextState.fermenterTankSelectedIndex = fermenterTankSelected.index;
        nextState.briteTankSelectedIndex = null;
    } else {
        const briteTankSelected = DashboardModalUtils.getBriteTank(nextState.briteTankMenuItems, { briteTank: tankClicked });
        nextState.briteTankSelected = briteTankSelected.item;
        nextState.briteTankSelectedIndex = briteTankSelected.index;
        nextState.fermenterTankSelectedIndex = null;
    }
    return nextState;
}

function getExistingModalState(oldState, orderDateClicked, isFermenterTankClicked, tankTypeClicked, isBHAllowed) {
    let nextState = {};
    let order = cloneDeep(oldState.order) || cloneDeep(oldState);

    if (order && !isBHAllowed) {
        order.batchs = null;
    }

    nextState.order = order;
    nextState.isVolumeAlreadySuggested = true; // in edit mode not need to suggest
    nextState.isFermenterTankClicked = isFermenterTankClicked;
    nextState.tankTypeClicked = tankTypeClicked;
    nextState.isNewModal = false;
    nextState.isSingle = false;
    nextState.shouldNeedValidate = true;
    nextState.brewDate = DateUtils.toDate(order.brewDate);
    nextState.filtrationDate = DateUtils.toDate(order.filtrationDate);
    nextState.orderDate = DateUtils.toDate(order.orderDate);

    nextState = _recalculateLayout(nextState);
    nextState = _initMenuItems(nextState);

    const styleBeerSelected = getStyleBeer(nextState.beerStyleMenuItems, order);
    const briteTankSelected = getBriteTank(nextState.briteTankMenuItems, order);
    const fermenterTankSelected = getFermenterTank(nextState.fermenterTankMenuItems, order);

    nextState.styleBeerSelectedIndex = styleBeerSelected.index;
    nextState.styleBeerSelected = styleBeerSelected.item;
    nextState.briteTankSelectedIndex = briteTankSelected.index;
    nextState.briteTankSelected = briteTankSelected.item;
    nextState.fermenterTankSelectedIndex = fermenterTankSelected.index;
    nextState.fermenterTankSelected = fermenterTankSelected.item;
    nextState.commentOrder = order.comment;
    nextState.orderVolume = ContentUtils.getNumber(order.volume);
    nextState.orderVolumePristine = ContentUtils.getNumber(order.volume);
    nextState.fermenterTasks = setTaskIds(order.fermenterTasks, TYPE_TASK_FERMENTER);
    nextState.packagingTasks = setTaskIds(order.packagingTasks, TYPE_TASK_PACKAGING);
    nextState.dataClicked = orderDateClicked;
    nextState.isFermenterTankClicked = isFermenterTankClicked;
    nextState.batchNumber = order.batchNumber;

    if (BrewhouseStore.isSomeBatchChange(get(oldState, 'order.batchs', []), get(nextState, 'order.batchs', []))) {
        nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);
        nextState.batchs = get(nextState, 'order.batchs');
    }

    return nextState;
}

function _someProductAlreadyConfirmed(nextState) {
    const products = OrderUtils.getAllProductsFromOrder(nextState.order);
    nextState.isSomeProductAlreadyConfirmed = some(products, product => {
        return get(product, 'isConfirmed');
    });
    return nextState;
}

function onChangeBeerStyle(oldState, menuItem, selectedTankType, isBHAllowed) {
    let nextState = cloneDeep(oldState) || {};

    nextState.styleBeerTextColor = 'inherit';
    nextState.styleBeerSelected = menuItem;
    nextState.styleBeerSelectedIndex = get(menuItem, 'payload');
    nextState.shouldNeedValidate = true;
    nextState.isBeerStyleAlreadyDefined = true;

    nextState = _recalculateDates(nextState, selectedTankType);
    nextState = _recalculateLayout(nextState);
    nextState = _initInitialTasks(nextState);
    nextState = _initNewTasksWithConfiguration(nextState);
    nextState = _initMenuItems(nextState);
    nextState = _suggestionTank(nextState, true);
    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);
    nextState = _hydratedTasksWithProducts(nextState);
    nextState = InventoryStore.hydrateTaskWithProductsAmount(nextState);
    nextState = _updateOrderWithScopeEstimation(nextState); // the icons colors inventory

    return nextState;
}

function _updateOrderWithScopeEstimation(nextState) {
    const ordersWithInventoryScope = InventoryStore.hydrateOrderTaskWithInventoryScopeEstimation([nextState.order, ...OrderStore.getOrders()]);
    nextState.order = ordersWithInventoryScope.find(order => order.id === nextState.order.id);
    return nextState;
}

function onChangeBrewDate(oldState, brewDate, isBHAllowed, nonForceUpdate) {
    let nextState = cloneDeep(oldState) || {};

    nextState.brewDate = brewDate;
    nextState.offsetY = ChronologycStore.getYFromDate(DateUtils.toDateText(brewDate)) - ChronologycStore.getYFromDate(DateUtils.toDateText(nextState.brewDate));

    nextState = _recalculateLayout(nextState);
    nextState = _recalculateTasks(nextState);
    nextState = _initMenuItems(nextState);
    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);

    if (!nonForceUpdate) {
        nextState.shouldNeedValidate = true;
    }

    return nextState;
}

function _hydratedTasksWithProducts(nextState) {
    if (SessionStore.isFullPaidVersion()) {
        const order = get(nextState, 'order');
        const beerStyleId = get(nextState, 'styleBeerSelected.id');
        nextState.fermenterTasks = InventoryStore.hydrateTaskWithProducts(nextState.fermenterTasks, beerStyleId);
        nextState.packagingTasks = InventoryStore.hydrateTaskWithProducts(nextState.packagingTasks, beerStyleId);
        order.batchs = InventoryStore.hydrateTaskWithProducts(DateUtils.sortListByDateField(order.batchs, 'date'), beerStyleId);
    }
    return nextState;
}

function _sinchronizedInnerOuterOrderDates(nextState) {
    nextState = set(nextState, 'order.brewDate', DateUtils.toDateText(nextState.brewDate));
    nextState = set(nextState, 'order.filtrationDate', DateUtils.toDateText(nextState.filtrationDate));
    nextState = set(nextState, 'order.orderDate', DateUtils.toDateText(nextState.orderDate));

    // update batch date
    if (nextState.offsetY) {
        nextState = set(nextState, 'order.batchs', map(get(nextState, 'order.batchs'), batch => {
            const newBatchDate = DateUtils.addDays(DateUtils.toDate(batch.date), nextState.offsetY);
            batch.date = DateUtils.toDateText(newBatchDate);
            return batch;
        }));
    }
    return nextState;
}

/**
 * Load the BriteTank, FermenterTank and BeerStyle MenuItems to the State.
 *
 * @argument {Object} state         The state component.
 * @private
 */
function _initMenuItems(state) {
    let nextState = cloneDeep(state) || {};
    nextState = _updateFermenterAndBriteTankAvailability(nextState);
    nextState = _initBriteTankMenuItem(nextState);
    nextState = _initFermenterTankMenuItem(nextState);
    nextState = _initBeerStyleMenuItems(nextState);
    return nextState;
}

function _updateFermenterAndBriteTankAvailability(nextState) {
    let briteTankAvailables,
        fermenterTankAvailables;

    const brewDate = nextState.brewDate,
        filtrationDate = nextState.filtrationDate,
        orderDate = nextState.orderDate;

    if (brewDate && filtrationDate && orderDate) {
        if (nextState.isNewModal) {
            briteTankAvailables = TankStore.getAvailabilityTanks(filtrationDate, orderDate, 'BT', null, DashboardModalStore.getCurrentLayout());
            fermenterTankAvailables = TankStore.getAvailabilityTanks(brewDate, filtrationDate, 'FV', null, DashboardModalStore.getCurrentLayout());
        } else {
            briteTankAvailables = TankStore.getAvailabilityTanks(filtrationDate, orderDate, 'BT', nextState.order.id, DashboardModalStore.getCurrentLayout());
            fermenterTankAvailables = TankStore.getAvailabilityTanks(brewDate, filtrationDate, 'FV', nextState.order.id, DashboardModalStore.getCurrentLayout());
        }

        nextState.briteTankAvailables = briteTankAvailables;
        nextState.fermenterTankAvailables = fermenterTankAvailables;

        if (!isTankSelectedAvailable(nextState.fermenterTankAvailables, get(nextState, 'fermenterTankSelected.id') || get(nextState, 'fermenterTankSelected.tankObj.id'))) {
            nextState.fermenterTankSelected = null;
        }
        if (!isTankSelectedAvailable(nextState.briteTankAvailables, get(nextState, 'briteTankSelected.id') || get(nextState, 'briteTankSelected.tankObj.id'))) {
            nextState.briteTankSelected = null;
        }
    }
    return nextState;
}

function isTankSelectedAvailable(tanksAvailable, tankSelectedId) {
    return tanksAvailable
        .filter(tank => tank.isAvailable)
        .some(tank => tank.id === tankSelectedId);
}


function _initBriteTankMenuItem(nextState) {
    const tanks = TankStore.getTanks();
    let briteTankMenuItems = getNonSelectedMenuItem(t('dashboard_modal_general_packaging_tank_placeholder'));
    briteTankMenuItems = briteTankMenuItems.concat(toTankMenuItems('BT', tanks, 'modal-order-tank-bt-'));
    nextState.briteTankMenuItems = _filterTanksByAvailability(nextState, briteTankMenuItems, nextState.briteTankAvailables);
    return nextState;
}

function _initFermenterTankMenuItem(nextState) {
    const tanks = TankStore.getTanks();
    let fermenterTankMenuItems = getNonSelectedMenuItem(t('dashboard_modal_general_fermenting_tank_placeholder'));
    fermenterTankMenuItems = fermenterTankMenuItems.concat(toTankMenuItems('FV', tanks, 'modal-order-tank-fv-'));
    nextState.fermenterTankMenuItems = _filterTanksByAvailability(nextState, fermenterTankMenuItems, nextState.fermenterTankAvailables);
    return nextState;
}

function _initBeerStyleMenuItems(nextState) {
    let beerStyleMenuItems = getNonSelectedMenuItem(t('dashboard_modal_general_beer_style_placeholder'));
    const isNewModal = nextState.isNewModal;
    const beerStyles = isNewModal ? filter(BeerStyleStore.getBeerStyles(), beerStyle => beerStyle.enable === true || beerStyle.enable === undefined) : BeerStyleStore.getBeerStyles();
    beerStyleMenuItems = concat(beerStyleMenuItems, map(beerStyles, (beerStyle, index) => {
        return Object.assign(beerStyle, {
            payload: index + 1,
            text: beerStyle.name,
            locatorId: `modal-order-beer-style-locator-${index}`
        });
    }));

    nextState.beerStyleMenuItems = beerStyleMenuItems;
    return nextState;
}

//TODO: need refactor this methods, is really really ugly :p
/**
 * Change the state of tank suggestion depended if it needed.
 *
 * NOTE: In order to calculate properly the suggestion, is necessary that state context already
 * have the fermenter, brite tank available and menu item already loaded.
 * @argument state {Object} Is the current state of the component
 * @private
 */
function _changeSuggestionTank(state, avoidRecalculateTasks) {
    let fermenterTankAvailable,
        briteTankAvailable,
        fermenterSuggestedAvailable,
        briteTankSuggestedAvailable,
        nextState = cloneDeep(state) || {},
        isFVSelected;

    isFVSelected = isFermenterTankSelected(state);

    let cntIntRescue = 0;

    if (isFVSelected) {

        // find current fermenter selected if availables
        fermenterTankAvailable = find(nextState.fermenterTankAvailables, fermenter => {
            return nextState.fermenterTankSelected && fermenter.id === get(nextState, 'fermenterTankSelected.tankObj.id');
        });

        while (!fermenterTankAvailable || !briteTankAvailable) {
            cntIntRescue++;

            if (cntIntRescue > 40) {
                //FIXME: WE NEED TO RESOLVE THIS
                break;
            }

            // search until found both tanks available
            if (!fermenterTankAvailable || !fermenterTankAvailable.isAvailable) {
                // enter here means that current tank selected is not available, so we need to find another one
                fermenterTankAvailable = TankStore.getNextFermenterTankAvailable(state.brewDate, state.filtrationDate, get(state, 'order.id'), ContentUtils.getNumber(nextState.orderVolume), DashboardModalStore.getCurrentLayout());
            }

            if (fermenterTankAvailable) {
                let volumeTarget = ContentUtils.getNumber(fermenterTankAvailable.volume);
                const maxBTCountTanks = get(nextState.briteTankAvailables, 'length');
                let cntBTSearchRetries = 0;

                while (!briteTankAvailable && cntBTSearchRetries < maxBTCountTanks) {
                    // enter here means that we could not have a brite tank available, so we need to search another BT available starting with current FV volume target,
                    // If don't found with current FV target volumen, we search with less volume target of BR tanks.
                    // If dont have any of BT availables of BT tanks we will set briteTanksAvailables null;
                    cntBTSearchRetries++;
                    briteTankAvailable = TankStore.getNextBriteTankAvailable(state.filtrationDate, state.orderDate, get(state, 'order.id'), volumeTarget, DashboardModalStore.getCurrentLayout());
                    if (!briteTankAvailable) {
                        const nextBTWithLessVolume = _getNextTankWithLessVolume(nextState.briteTankAvailables, volumeTarget);
                        volumeTarget = ContentUtils.getNumber(get(nextBTWithLessVolume, 'volume'));
                        if (nextBTWithLessVolume && nextBTWithLessVolume.isAvailable) {
                            briteTankAvailable = nextBTWithLessVolume;
                        }
                    }
                }

                if (briteTankAvailable) {
                    // enter here means that we found fermenter and brite tank available, and we need to update order volume with the less of both, FINISH!!
                    nextState = _updateOrderVolumeIfNeed(nextState, briteTankAvailable, volumeTarget);
                } else {
                    // let with `fermenterTankAvailable` with tank selected and `briteTankAvailable` with non tank selected.
                    break;
                }
            } else {
                // enter here means that dont found tank avaiable so, we need to check tank with less volume
                let cntSearchRetries = 0;
                const maxCountTanks = get(nextState.fermenterTankAvailables, 'length');

                while (!fermenterTankAvailable && cntSearchRetries < maxCountTanks) {
                    cntSearchRetries++;
                    fermenterTankAvailable = _getNextTankWithLessVolume(nextState.fermenterTankAvailables, get(nextState, 'orderVolume')); // we need to use fermenter tank selected
                    if (fermenterTankAvailable && !nextState.isVolumeAlreadySuggested) {
                        nextState.isVolumeAlreadySuggested = true;
                        nextState.orderVolume = ContentUtils.getNumber(fermenterTankAvailable.volume);
                    }
                }

                if (!fermenterTankAvailable) {
                    // enter here means that we could not found any fermenter tank available, so let `fermenterTankAvailable` null
                    break;
                }
            }
        }
    } else {
        // find current brite tank selected if availables
        briteTankAvailable = find(nextState.briteTankAvailables, briteTank => {
            return nextState.briteTankSelected && briteTank.id === get(nextState, 'briteTankSelected.tankObj.id');
        });

        while (!fermenterTankAvailable || !briteTankAvailable) {
            cntIntRescue++;
            if (cntIntRescue > 40) {
                //FIXME: WE NEED TO RESOLVE THIS
                break;
            }

            // search until found both tanks available
            if (!briteTankAvailable || !briteTankAvailable.isAvailable) {
                // enter here means that current tank selected is not available, so we need to find another one
                briteTankAvailable = TankStore.getNextBriteTankAvailable(state.filtrationDate, state.orderDate, get(state, 'order.id'), nextState.orderVolume, state.currentLayout);
            }

            if (briteTankAvailable) {
                let volumeTarget = ContentUtils.getNumber(briteTankAvailable.volume);
                const maxFVCountTanks = get(nextState.fermenterTankAvailables, 'length');
                let cntFVSearchRetries = 0;

                while (!fermenterTankAvailable && cntFVSearchRetries < maxFVCountTanks) {
                    // enter here means that we could not have a ferementer tank available, so we need to search another FV available starting with current BT volumen target,
                    // If don't found with current BT target volumen, we search with less volume target of FV tanks.
                    // If dont have any of FV availables of FV tanks we will set fermentertankAvailable null;
                    cntFVSearchRetries++;
                    fermenterTankAvailable = TankStore.getNextFermenterTankAvailable(state.brewDate, state.filtrationDate, get(state, 'order.id'), volumeTarget, state.currentLayout);
                    if (!fermenterTankAvailable) {
                        const nextFVWithLessVolume = _getNextTankWithLessVolume(nextState.fermenterTankAvailables, volumeTarget, state.currentLayout);
                        volumeTarget = ContentUtils.getNumber(get(nextFVWithLessVolume, 'volume'));
                        if (nextFVWithLessVolume && nextFVWithLessVolume.isAvailable) {
                            fermenterTankAvailable = nextFVWithLessVolume;
                        }
                    }
                }

                if (fermenterTankAvailable) {
                    // enter here means that we found fermenter and brite tank available, and we need to update order volume with the less of both, FINISH!!
                    nextState = _updateOrderVolumeIfNeed(nextState, fermenterTankAvailable);
                } else {
                    // let with `briteTankAvailable` with tank selected and `ferementerTankAvailable` with non tank selected.
                    break;
                }
            } else {
                // enter here means that dont found tank avaiable so, we need to check tank with less volume
                let cntSearchRetries = 0;
                const maxCountTanks = get(nextState.briteTankAvailables, 'length');

                while (!briteTankAvailable && cntSearchRetries < maxCountTanks) {
                    cntSearchRetries++;
                    briteTankAvailable = _getNextTankWithLessVolume(nextState.briteTankAvailables, get(nextState, 'orderVolume')); // we need to use fermenter tank selected
                    if (briteTankAvailable && !nextState.isVolumeAlreadySuggested) {
                        nextState.isVolumeAlreadySuggested = true;
                        nextState.orderVolume = ContentUtils.getNumber(briteTankAvailable.volume);
                    }
                }

                if (!briteTankAvailable) {
                    // enter here means that we could not found any briteTank tank available, so let `briteTankAvailable` null
                    break;
                }
            }
        }

    }

    // fill index tank tank selected in order to use in menu item.
    fermenterSuggestedAvailable = toTankMenuItem(nextState.fermenterTankAvailables, fermenterTankAvailable);
    nextState.fermenterTankSelectedIndex = fermenterSuggestedAvailable.index;
    nextState.fermenterTankSelected = fermenterSuggestedAvailable.item;
    if (nextState.fermenterTankSelected) {
        nextState.fermenterTankSelected.tankObj = cloneDeep(fermenterSuggestedAvailable.item); // clone in order to break circular reference and make tankObj in order to be compatible with menu item structure

    }
    // Find BT the most efficient as possible.
    briteTankSuggestedAvailable = toTankMenuItem(nextState.briteTankAvailables, briteTankAvailable);
    nextState.briteTankSelectedIndex = briteTankSuggestedAvailable.index;
    nextState.briteTankSelected = briteTankSuggestedAvailable.item;
    if (nextState.briteTankSelected) {
        nextState.briteTankSelected.tankObj = cloneDeep(briteTankSuggestedAvailable.item); // clone in order to break circular reference and make tankObj in order to be compatible with menu item
    }

    if (!avoidRecalculateTasks) {
        // Update fermenter and packaging tasks
        var orderInfo = {
            brewDate: DateUtils.toDateText(nextState.brewDate),
            filtrationDate: DateUtils.toDateText(nextState.filtrationDate),
            orderDate: DateUtils.toDateText(nextState.orderDate),
            fermenterTasks: nextState.fermenterTasks,
            packagingTasks: nextState.packagingTasks
        };
        orderInfo = OrderStore.recalculateOrderTasks(orderInfo, false);
        nextState.fermenterTasks = orderInfo.fermenterTasks;
        nextState.packagingTasks = orderInfo.packagingTasks;
    }

    return nextState;
}

function _suggestionTank(state) {

    let fermenterTankAvailable,
        briteTankAvailable,
        fermenterTankAvailableMenuItem,
        briteTankAvailableMenuItem,
        nextState = cloneDeep(state) || {};

    const isFVSelected = isFermenterTankSelected(state);
    const volumeTarget = ContentUtils.getNumber(nextState.orderVolume);

    if (isFVSelected) {
        // check the availability of current Fermenter tank selected
        fermenterTankAvailable = find(nextState.fermenterTankAvailables, fermenter => {
            return nextState.fermenterTankSelected && fermenter.id === get(nextState, 'fermenterTankSelected.tankObj.id');
        });

        briteTankAvailable = TankStore.getNextBriteTankAvailable(state.filtrationDate, state.orderDate, get(state, 'order.id'), volumeTarget, state.currentLayout);
    } else {
        // find current brite tank selected if availables
        briteTankAvailable = find(nextState.briteTankAvailables, briteTank => {
            return nextState.briteTankSelected && briteTank.id === get(nextState, 'briteTankSelected.tankObj.id');
        });
        fermenterTankAvailable = TankStore.getNextFermenterTankAvailable(state.brewDate, state.filtrationDate, get(state, 'order.id'), volumeTarget, state.currentLayout);
    }

    // Define Brite tank
    if (briteTankAvailable && briteTankAvailable.isAvailable) {
        briteTankAvailableMenuItem = briteTankAvailable;
        // Find BT the most efficient as possible.
        briteTankAvailableMenuItem = toTankMenuItem(nextState.briteTankAvailables, briteTankAvailableMenuItem);
        nextState.briteTankSelectedIndex = briteTankAvailableMenuItem.index;
        nextState.briteTankSelected = briteTankAvailableMenuItem.item;
        if (nextState.briteTankSelected) {
            nextState.briteTankSelected.tankObj = cloneDeep(briteTankAvailableMenuItem.item); // clone in order to break circular reference and make tankObj in order to be compatible with menu item
        }
    } else {
        // enter here means that current brite tank selected is not available so we clean tank selected from dashboard
        nextState.briteTankSelectedIndex = 0;
        nextState.briteTankSelected = null;
    }

    // Define Fermenting tank
    if (fermenterTankAvailable && fermenterTankAvailable.isAvailable) {
        fermenterTankAvailableMenuItem = fermenterTankAvailable;
        // fill index tank tank selected in order to use in menu item.
        fermenterTankAvailableMenuItem = toTankMenuItem(nextState.fermenterTankAvailables, fermenterTankAvailableMenuItem);
        nextState.fermenterTankSelectedIndex = fermenterTankAvailableMenuItem.index;
        nextState.fermenterTankSelected = fermenterTankAvailableMenuItem.item;
        if (nextState.fermenterTankSelected) {
            nextState.fermenterTankSelected.tankObj = cloneDeep(fermenterTankAvailableMenuItem.item); // clone in order to break circular reference and make tankObj in order to be compatible with menu item structure
        }
    } else {
        // enter here means that current brite tank selected is not available so we clean tank selected from dashboard
        nextState.fermenterTankSelectedIndex = 0;
        nextState.fermenterTankSelected = null;
    }

    return nextState;
}

function isFermenterTankSelected(state) {
    let isFVSelected;

    if (state.fermenterTankSelected !== undefined && state.briteTankSelected !== undefined) {
        isFVSelected = get(state, 'isFermenterTankClicked');
    } else {
        isFVSelected = !!state.fermenterTankSelected;
    }
    return isFVSelected;
}


function _updateOrderVolumeIfNeed(nextState, lastTankChanged) {
    const volumeTankChanged = ContentUtils.getNumber(get(lastTankChanged, 'volume'));
    if (get(nextState, 'orderVolume') > volumeTankChanged && !nextState.isVolumeAlreadySuggested) {
        nextState.isVolumeAlreadySuggested = true;
        nextState = set(nextState, 'orderVolume', volumeTankChanged);
    }
    return nextState;
}

function _getNextTankWithLessVolume(tanksAvailables, currentVolumeTank) {
    const tanksSorted = sortBy(cloneDeep(tanksAvailables), 'volume'); // clone deep in order to lose reference
    return last(tanksSorted, tank => tank.volume < (currentVolumeTank || 0)); // take the last one already sorted tank with less of current volume tank
}

function toTankMenuItem(availables, mostSuitableTank) {
    //const availablesFiltered = filter(availables, tank => tank.isAvailable);
    return {
        index: findIndex(availables, tank => get(tank, 'id') === get(mostSuitableTank, 'id')) + 1, // increment 1, in order to avoir the first item eg: 'Select item....'
        item: mostSuitableTank
    };
}

/**
 * Initialize default task.
 * @param {Object} nextState
 * @private
 * @returns {Object}
 */
function _initInitialTasks(nextState) {
    nextState = _initFermentingTask(nextState);
    nextState = _initPackagingTask(nextState);

    return nextState;
}

function _initFermentingTask(nextState) {
    const brewDateText = DateUtils.toDateText(nextState.brewDate),
        filtrationDateText = DateUtils.toDateText(nextState.filtrationDate);

    let fermenterTasks = [];

    const brewTask = DashboardModalUtils.toEmptyTask(brewDateText, BREW_TASK);
    const fermenterTask = DashboardModalUtils.toEmptyTask(filtrationDateText, FILTRATION_TASK);
    fermenterTasks.push(brewTask);
    fermenterTasks.push(fermenterTask);
    nextState.fermenterTasks = fermenterTasks;

    return nextState;
}

function _initPackagingTask(nextState) {
    const orderDateText = DateUtils.toDateText(nextState.orderDate),
        packagingTask = DashboardModalUtils.toEmptyTask(orderDateText, PACKAGING_TASK);
    let packagingTasks = [];

    packagingTasks.push(packagingTask);
    nextState.packagingTasks = packagingTasks;

    return nextState;
}

function _initNewTasksWithConfiguration(state) {
    // Only into NEW order operation we use the beer style configuration.
    if (state.styleBeerSelected) {
        let nextState = {};

        // Remove if exist other task configuration apply before in order to allow re-calculate the new days positions.
        nextState.fermenterTasks = filter(state.fermenterTasks, task => !task.isConfiguration);
        nextState.packagingTasks = filter(state.packagingTasks, task => !task.isConfiguration);

        // the fermenting configuration task for the current beer style.
        let fermenterTaskConfiguration = filter(DashboardServiceCache.getBeerStyleTaskConfiguration(), task => {
            return task.styleBeerId === +state.styleBeerSelected.id && task.typeTank === FERMENTER_TYPE_TASK;
        });

        if (fermenterTaskConfiguration && fermenterTaskConfiguration.length) {
            const fermenterTasksHydrated = concat(nextState.fermenterTasks, fermenterTaskConfiguration);
            const fermenterTasks = toConcreteTask(fermenterTasksHydrated, state.brewDate, DashboardServiceCache.getFermenterIcons(), 'FV');

            nextState.fermenterTasks = DashboardModalUtils.removeDefaultTaskWhenExistCustom(fermenterTasks);
        }

        // the packaging configuration task for the current beer style.
        let packagingTaskConfiguration = filter(DashboardServiceCache.getBeerStyleTaskConfiguration(), task => {
            return task.styleBeerId === +state.styleBeerSelected.id && task.typeTank === PACKAGING_TYPE_TASK;
        });

        // apply configuration if match with current beer style.
        if (packagingTaskConfiguration && packagingTaskConfiguration.length) {
            const packaginTasksHydrated = concat(nextState.packagingTasks, packagingTaskConfiguration);
            const packaginTasks = toConcreteTask(packaginTasksHydrated, state.filtrationDate, DashboardServiceCache.getPackagingIcons(), 'BT');

            nextState.packagingTasks = DashboardModalUtils.removeDefaultTaskWhenExistCustom(packaginTasks);
        }
        return assign(state, nextState);
    }

    return state;
}

function _recalculateDates(state, selectedTankType) {
    const { styleBeerSelected, brewDate, orderDate } = state;

    if (styleBeerSelected) {
        let nextState = {};
        if (selectedTankType === TYPE_TANK_BRITE_TANK) {
            // enter here means we are creating the order from fermenting section
            const newBrewDate = DateUtils.addDays(orderDate, -Math.abs(styleBeerSelected.packagingDays + styleBeerSelected.fermenterDays - 2));
            const newFiltrationDate = DateUtils.addDays(orderDate, -Math.abs(styleBeerSelected.packagingDays - 1));

            nextState.filtrationDate = newFiltrationDate;
            nextState.offsetY = ChronologycStore.getYFromDate(newBrewDate);
            nextState.brewDate = newBrewDate;

            return assign(state, nextState);

        } else if (selectedTankType === TYPE_TANK_FERMENTER || selectedTankType === TYPE_TANK_BREW_HOUSE) {
            // enter here means we are creating the order from packaging section
            const newOrderDate = DateUtils.addDays(brewDate, (styleBeerSelected.fermenterDays + styleBeerSelected.packagingDays) - 2);
            const newFiltrationDate = DateUtils.addDays(brewDate, styleBeerSelected.fermenterDays - 1);

            nextState.offsetY = 0; // Shold not change vertical position because we create order from Fermenting section, so the brew date still are the same.
            nextState.filtrationDate = newFiltrationDate;
            nextState.orderDate = newOrderDate;

            return assign(state, nextState);
        }
    }
    return state;
}

/**
 * Filter the tanks unavailables of the menu items defined.
 * @argument {Object} state   Which containt information about state.
 * @argument {Array} menuItems the items that substract the tanks unavailables.
 * @argument {Object} TankAvailables.
 * @return {Array}
 * @private
 */
function _filterTanksByAvailability(state, menuItems, tankAvailables) {
    if (menuItems && tankAvailables) {
        if (!state.isNewModal && !state.order) { // Means that will call this method in close modal after was cleaned.
            return [];
        }
        menuItems = filter(menuItems, menuItem => {
            const tankState = find(tankAvailables, tankAvailable => {
                return menuItem.column !== undefined &&
                    menuItem.column !== null &&
                    menuItem.column === tankAvailable.column;
            });
            if (tankState) {
                if (!state.isNewModal && !tankState.isAvailable) {
                    return state.order.id === tankState.idOrderCollision;
                } else {
                    // show allays by availability the tank, it doesn't matter the volume that tank will have
                    return tankState.isAvailable;
                }
            } else {
                // enter here means when is first item of dropdown like "Select item ...."
                return true;
            }
        });
    }
    return menuItems;
}

/**
 * Compute the properly next state of Task when it change.
 * @param {String} targetValue
 * @param {String} existingPackagingTask
 * @param {String} existingFermenterTasks
 * @param {String} typeTask
 * @param {String} dateTask
 * @param {String} field
 */
function onChangeTask(targetValue, existingPackagingTask, existingFermenterTasks, typeTask, dateTask, field) {
    let newTask,
        nextState = {};

    if (typeTask === TYPE_TASK_PACKAGING) {

        let existingPackagingTaskSafe = DashboardModalUtils.removeDefaultTaskWhenExistCustom(existingPackagingTask);
        newTask = find(existingPackagingTaskSafe, task => task.date === dateTask);

        if (!newTask) {
            newTask = DashboardModalUtils.toEmptyTask(dateTask);
            existingPackagingTaskSafe.push(newTask);
        }

        newTask[field] = targetValue;
        nextState = {
            packagingTasks: ContentUtils.replace(existingPackagingTaskSafe, newTask, 'date')
        };

    } else if (typeTask === TYPE_TASK_FERMENTER) {

        let existingFermenterTaskSafe = DashboardModalUtils.removeDefaultTaskWhenExistCustom(existingFermenterTasks);
        newTask = find(existingFermenterTaskSafe, task => task.date === dateTask);

        if (!newTask) {
            newTask = DashboardModalUtils.toEmptyTask(dateTask);
            existingFermenterTaskSafe.push(newTask);
        }

        newTask[field] = targetValue;
        nextState = {
            fermenterTasks: ContentUtils.replace(existingFermenterTaskSafe, newTask, 'date')
        };
    }
    return nextState;
}


function onDeleteTask(existingPackagingTask, existingFermenterTasks, typeTask, dateTask) {
    let nextState = {};
    if (typeTask === TYPE_TASK_PACKAGING) {
        nextState = {
            packagingTasks: filter(existingPackagingTask, function (task) {
                return task.date !== dateTask;
            })
        };
    } else {
        nextState = {
            fermenterTasks: filter(existingFermenterTasks, function (task) {
                return task.date !== dateTask;
            })
        };
    }
    return nextState;
}

/**
 * Check all of fields of the order form and will indicate the errores founds.
 * @argument {Object} self The context that was invoke.
 * @return {Boolean}
 * @private
 */
function isValidForm(state) {
    let messagesError = {
        brewDateMessageError: null,
        filtrationDateMessageError: null,
        styleBeerMessageError: null,
        briteTankMessageError: null,
        fermenterTankMessageError: null,
        orderDateMessageError: null,
        volumenTankMessageError: null
    },
        isValid = true;

    if (!state.brewDate) {
        messagesError.brewDateMessageError = t('dashboard_modal_general_brew_date_required');
        isValid = false;
    } else if (DateUtils.isAfter(DateUtils.toDateText(state.brewDate), DateUtils.toDateText(state.filtrationDate)) ||
        DateUtils.isAfter(DateUtils.toDateText(state.brewDate), DateUtils.toDateText(state.orderDate)) ||
        DateUtils.isEqual(DateUtils.toDateText(state.brewDate), DateUtils.toDateText(state.filtrationDate))) {
        messagesError.brewDateMessageError = t('dashboard_modal_general_brew_date_inline_error_should_be_before_transfer_date');
        isValid = false;
    } else {
        messagesError.brewDateMessageError = '';
    }

    if (!state.filtrationDate) {
        messagesError.filtrationDateMessageError = t('dashboard_modal_general_transfer_date_inline_error_required');
        isValid = false;
    } else if (DateUtils.isAfter(DateUtils.toDateText(state.filtrationDate), DateUtils.toDateText(state.orderDate)) ||
        DateUtils.isBefore(DateUtils.toDateText(state.filtrationDate), DateUtils.toDateText(state.brewDate))) {
        messagesError.filtrationDateMessageError = t('dashboard_modal_general_transfer_date_inline_error_should_chronological');
        isValid = false;
    } else {
        messagesError.filtrationDateMessageError = '';
    }

    if (!state.orderDate) {
        messagesError.orderDateMessageError = t('dashboard_modal_general_packaging_date_required');
        isValid = false;
    } else if (DateUtils.isEqual(DateUtils.toDateText(state.orderDate), DateUtils.toDateText(state.filtrationDate))) {
        messagesError.orderDateMessageError = '';
    } else if (DateUtils.isBefore(DateUtils.toDateText(state.orderDate), DateUtils.toDateText(state.filtrationDate)) ||
        DateUtils.isBefore(DateUtils.toDateText(state.orderDate), DateUtils.toDateText(state.brewDate))) {
        messagesError.orderDateMessageError = t('dashboard_modal_general_packaging_date_inline_error_should_chronological');
        isValid = false;
    } else {
        messagesError.orderDateMessageError = '';
    }

    if (!state.styleBeerSelected || !state.styleBeerSelected.id) {
        messagesError.styleBeerMessageError = t('dashboard_modal_general_beer_style_inline_error');
        isValid = false;
    } else {
        messagesError.styleBeerMessageError = '';
    }

    if (get(state, 'fermenterTankMenuItems.length') === 1) {
        messagesError.fermenterTankMessageError = t('dashboard_modal_general_tank_inline_error_no_space');
        isValid = false;
    } else if (!state.fermenterTankSelected ||
        state.fermenterTankSelected.column === undefined ||
        state.fermenterTankSelected.column < 0
    ) {
        messagesError.fermenterTankMessageError = t('dashboard_modal_general_transfer_date_inline_error_required');
        isValid = false;
    } else if (ContentUtils.getNumber(state.orderVolume) > get(state, 'fermenterTankSelected.tankObj.volume')) {
        messagesError.fermenterTankMessageError = t('dashboard_modal_general_fermenting_tank_inline_error_no_enough_volume');
        isValid = false;
    } else {
        messagesError.fermenterTankMessageError = '';
    }

    if (get(state, 'briteTankMenuItems.length') === 1) {
        messagesError.briteTankMessageError = t('dashboard_modal_general_tank_inline_error_no_space');
        isValid = false;
    } else if (!state.briteTankSelected || !state.briteTankSelected.column) {
        messagesError.briteTankMessageError = t('dashboard_modal_general_packaging_tank_inline_error_required');
        isValid = false;
    } else if (ContentUtils.getNumber(state.orderVolume) > get(state, 'briteTankSelected.tankObj.volume')) {
        messagesError.briteTankMessageError = t('dashboard_modal_general_packaging_tank_inline_error_no_enough_volume');
        isValid = false;
    } else {
        messagesError.briteTankMessageError = '';
    }

    const brewhouseMessageError = get(state, 'order.brewhouseMessageError');

    if (brewhouseMessageError) {
        messagesError.volumenTankMessageError = brewhouseMessageError;
        isValid = false;
    } else if (get(state, 'messagesError.volumenTankMessageError.length') > 0) {
        isValid = false;
        messagesError.volumenTankMessageError = get(state, 'messagesError.volumenTankMessageError');
    } else {
        messagesError.volumenTankMessageError = '';
    }

    return {
        isValid,
        messagesError
    };
}

function initializePackagingTask(self) {
    return _initializeOrderTasks(
        self.state.filtrationDate,
        self.state.orderDate,
        self.state.packagingTasks,
        DashboardServiceCache.getPackagingIcons(),
        TYPE_TASK_PACKAGING,
        self.state.dataClicked,
        self
    );
}

function initializeFermentingTask(self) {
    return _initializeOrderTasks(
        self.state.brewDate,
        self.state.filtrationDate,
        self.state.fermenterTasks,
        DashboardServiceCache.getFermenterIcons(),
        TYPE_TASK_FERMENTER,
        self.state.dataClicked,
        self
    );
}

function _initializeOrderTasks(fromDate,
    toDate,
    orderTasks,
    tasks,
    typeTask,
    dateTaskFocus,
    self) {
    let indexDay = -1,
        date,
        dateTask,
        taskEl = [],
        fromDateText,
        toDateText,
        existingTasks,
        dateTaskFocusText = dateTaskFocus ? DateUtils.toDateText(dateTaskFocus) : null,
        typeTaskClassName = '',
        isAlreadyExpanded = false;

    if (DateUtils.isAfter(DateUtils.toDateText(fromDate), DateUtils.toDateText(toDate))) {
        return;
    }

    const isEditMode = get(self, 'state.isNewModal') === false || get(self, 'state.isNewModal') === undefined;
    const shouldBeDisabled = !SessionStore.isAbleToEditAllWithoutDates();

    if (fromDate && toDate && orderTasks) {
        fromDateText = DateUtils.toDateText(fromDate);
        toDateText = DateUtils.toDateText(toDate);

        do {
            isAlreadyExpanded = false;
            let existingTask = null;
            indexDay++;
            date = moment(fromDateText, DATE_FORMAT).add(indexDay, 'days').format(DATE_FORMAT_DISPLAY_COMBO_DAY);
            dateTask = moment(fromDateText, DATE_FORMAT).add(indexDay, 'days').format(DATE_FORMAT);
            const keyAttr = `key-${indexDay}-${dateTask}-${typeTask}`;

            const safeOrderTask = filter(orderTasks, task => task); // remove undefined
            existingTasks = filter(safeOrderTask, task => task.date === dateTask);
            existingTask = retrieveCustomTask(existingTasks);

            if (existingTask) {
                existingTask.payload = getPayload(existingTask, tasks);
                // Add src task in order to avoid calculate later
                existingTask.imageSrc = get(find(tasks, task => task.displayName === existingTask.name), 'src');
                // Create and ID to later can use to Order Process
                existingTask.taskId = `${dateTask}_${typeTask}`;
                existingTask.sectionType = typeTask;
            } else {
                existingTask = {
                    date: dateTask,
                    payload: 1,
                    imageSrc: '',
                    taskId: `${dateTask}_${typeTask}`,
                    sectionType: typeTask
                };
            }

            // add default end hour product
            existingTask = OrderUtils.setDefaultEndHourToProductsOfTask(existingTask, dateTask);

            // hydrate with all field of each products
            existingTask = InventoryStore.hydrateProductWithDefaultAmountAndVolume(existingTask);

            if (dateTaskFocusText === dateTask) {
                typeTaskClassName += ' is-focused';
                isAlreadyExpanded = true;
            }

            const orderProcess = get(existingTask, 'process');
            const existingProcess = DashboardServiceCache.getProcessByType(typeTask);
            const orderProcessFiltered = filterOrderProcessByType(orderProcess, typeTask);

            taskEl.push(
                React.createElement(DashboardModalTaskCollapsible, {
                    onChangeProcess: self._onChangeProcess, 
                    onChangeProducts: self._onChangeProducts, 
                    onChangeAmountItem: self._onChangeAmountItem, 
                    onChangeVolumeItem: self._onChangeVolumeItem, 
                    onChangeAmountInLocation: self._onChangeAmountInLocation, 
                    onConfirmProduct: self._onConfirmProduct, 
                    orderProcess: orderProcessFiltered, 
                    order: self.state.order, 
                    date: date, 
                    uniqueId: keyAttr, 
                    isAlreadyExpanded: isAlreadyExpanded, 
                    existingProcess: existingProcess, 
                    indexDay: indexDay, 
                    shouldBeDisabled: shouldBeDisabled, 
                    typeTask: typeTask, 
                    typeTaskClassName: typeTaskClassName, 
                    existingTask: existingTask, 
                    tasks: tasks, 
                    isEditMode: isEditMode, 
                    // In this particularly case, I don't care the violation of LoD (Law of Demeter) in favor to DRY (Don't Repeat Your Self)
                    onChangeTaskType: self._onChangeTaskType.bind(self, existingTask, typeTask, dateTask), 
                    onBlurLabel: self._onChangeName.bind(self, existingTask, typeTask, dateTask), 
                    onBlurDescription: self._onChangeNote.bind(self, existingTask, typeTask, dateTask), 
                    onToggleExpand: self._onToggleExpand.bind(self, existingTask)}
                )
            );
        } while (moment(fromDateText, DATE_FORMAT).add(indexDay, 'days').format(DATE_FORMAT) !== toDateText);
    }

    return taskEl;
}

function getPayload(existingTask, tasks) {
    let payload = findIndex(tasks, task => task.name === existingTask.name);
    if (payload > -1) {
        return payload + 1;
    }
    return findIndex(tasks, task => task.displayName === existingTask.name) + 1;
}

function initializeBrewingTurns(batchs,
    onChangeBrewingTaskType,
    onChangeProcess,
    onChangeProducts,
    onChangeAmountItem,
    onChangeVolumeItem,
    onChangeAmountInLocation,
    dateTaskFocus,
    onConfirmProduct,
    self) {
    if (batchs) {
        let batchsEl = [], indexDay = -1, typeTaskClassName = '';
        const dateTaskFocusText = DateUtils.toDateText(dateTaskFocus);

        // fix same sorted orders
        const sortedBatchs = DashboardModalUtils.sortBatchByColumAndDate(batchs);
        const isEditMode = get(self, 'state.isEditMode');
        const isBrewingTankSelected = get(self, 'props.tankClicked.type') === 'BH';
        const shouldBeDisabled = !SessionStore.isAdminUser();

        for (let batch of sortedBatchs) {

            indexDay++;
            const date = moment(batch.date, DATE_FORMAT).format(DATE_FORMAT_DISPLAY_COMBO_DAY);
            const dateTask = moment(batch.date, DATE_FORMAT).format(DATE_FORMAT);
            const turnId = get(batch, 'turnId');
            const turnName = get(batch, 'turn.name');
            const process = get(batch, 'process', []);
            const keyAttr = `key-${indexDay}-${dateTask}-${turnId}`;

            const batchIconIndex = findIndex(DashboardServiceCache.getBrewhouseIcons(), icon => icon.name === batch.task || icon.displayName === batch.task);

            if (batchIconIndex === -1) {
                // enter here means that don't exist batch task, so we define by default no-icon the same way of Packaging and Fermenting Tabs
                batch.payload = findIndex(DashboardServiceCache.getBrewhouseIcons(), icon => icon.name === TASK_NON_VISIBLE) + 1;
            } else {
                batch.payload = batchIconIndex + 1; // increment one for menu items payload propose
            }

            if (isBrewingTankSelected && dateTaskFocusText === dateTask && get(self, 'props.tankClicked.name') === turnName) {
                typeTaskClassName += ' is-focused';
            }

            // Add a Common identifier between process of Brewhouse, Fermenting and Packaging
            batch.taskId = String(turnId);
            batch.sectionType = TYPE_TASK_BREWHOUSE;
            batch.day = indexDay;
            batch.date = dateTask;

            // add default end hour product
            batch = OrderUtils.setDefaultEndHourToProductsOfTask(batch, dateTask);

            // hydrate with all field of each products
            batch = InventoryStore.hydrateProductWithDefaultAmountAndVolume(batch);

            const brewingProcess = DashboardServiceCache.getBrewingProcess();
            const tasks = DashboardServiceCache.getBrewhouseIcons();
            const existingBatch = batch;
            const processFiltered = filterOrderProcessByType(process, TYPE_TASK_BREWHOUSE);


            batchsEl.push(
                React.createElement(DashboardModalTaskCollapsible, {
                    onChangeProcess: onChangeProcess, 
                    onChangeProducts: onChangeProducts, 
                    onChangeAmountItem: onChangeAmountItem, 
                    onChangeVolumeItem: onChangeVolumeItem, 
                    onChangeAmountInLocation: onChangeAmountInLocation, 
                    onConfirmProduct: onConfirmProduct, 
                    orderProcess: processFiltered, 
                    order: self.state.order, 
                    date: date, 
                    isEditMode: isEditMode, 
                    uniqueId: keyAttr, 
                    existingProcess: brewingProcess, 
                    name: turnName, 
                    indexDay: indexDay, 
                    shouldBeDisabled: shouldBeDisabled, 
                    typeTask: TYPE_TASK_BREWHOUSE, 
                    typeTaskClassName: typeTaskClassName, 
                    existingTask: existingBatch, 
                    tasks: tasks, 
                    onChangeTaskType: onChangeBrewingTaskType.bind(self, batch, dateTask, 'payload', turnId), 
                    onBlurLabel: self._onChangeName.bind(self, batch, 'BH', dateTask), 
                    onBlurDescription: self._onChangeNote.bind(self, batch, 'BH', dateTask), 
                    onToggleExpand: self._onToggleExpand.bind(self, batch)}
                )
            );
        }
        return batchsEl;
    }
    return batchs;
}

function filterOrderProcessByType(orderProcessList, type) {
    return filter(orderProcessList, orderProcess => {
        const taskId = get(orderProcess, 'taskId', '');
        if (includes(taskId, '_')) {
            // enter here means that have postfix, so we could be a FERMENTING or PACKAGING tasks.
            return includes(taskId, type);
        } else {
            // enter here means is a brewhouse task (without post_fix of taskId)
            return true;
        }
    });
}

function formatBatchs(consumerBatchs) {
    const batchs = map(consumerBatchs, consumerBatch => {
        let batch = {};
        batch.task = get(DashboardServiceCache.getBrewhouseIcons(), `${consumerBatch.payload - 1}.name`);
        batch.label = consumerBatch.label || '';
        batch.description = consumerBatch.description || '';
        batch.turnId = consumerBatch.turnId;
        batch.date = consumerBatch.date;
        batch.process = get(consumerBatch, 'process');
        batch.turn = consumerBatch.turn; // we need it to validate, this field will not be persisted in API
        batch.products = DashboardModalUtils.formatProducts(ContentUtils.filterEnable(consumerBatch.products), batch.date);
        return batch;
    });

    // fix same sorted orders
    const sortedBatchs = DashboardModalUtils.sortBatchByColumAndDate(batchs);

    return sortedBatchs;
}

function onChangeVolume(oldState, newVolume, isBHAllowed) {
    let nextState = cloneDeep(oldState);

    nextState = _recalculateLayout(nextState);
    nextState = _updateVolume(nextState, newVolume);
    nextState = _initMenuItems(nextState);

    if (nextState.isNewModal) {
        nextState = _recalculateFermenterTankByVolume(nextState);
        nextState = _recalculateBriteTankByVolume(nextState);
        nextState = _changeSuggestionTank(nextState);
    }

    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);
    nextState = DashboardModalUtils.fillEachBatchWithProductMissing(oldState, nextState);

    nextState.shouldNeedValidate = true;
    return nextState;
}

function onChangeVolumeNew(oldState, newVolume, isBHAllowed) {
    let nextState = cloneDeep(oldState);

    nextState = _recalculateLayout(nextState);
    nextState = _updateVolume(nextState, newVolume);
    nextState = _initInitialTasks(nextState);
    nextState = _initNewTasksWithConfiguration(nextState);
    nextState = _initMenuItems(nextState);
    nextState = _recalculateFermenterTankByVolume(nextState);
    nextState = _recalculateBriteTankByVolume(nextState);
    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);
    nextState = _changeSuggestionTank(nextState);
    nextState = _hydratedTasksWithProducts(nextState);
    nextState = InventoryStore.hydrateTaskWithProductsAmount(nextState);
    nextState = DashboardModalUtils.fillEachBatchWithProductMissing(oldState, nextState);

    nextState.shouldNeedValidate = true;
    return nextState;
}


function _recalculateBrewhouse(oldState, nextState, isBHAllowed) {
    // ask if change brewDate in order to update each batch date
    const offsetDays = DateUtils.getDaysBetween(oldState.brewDate || nextState.brewDate, nextState.brewDate);

    if (!isBHAllowed) {
        // enter here means that the toggle is off, so is not needed to update any batch
        return BrewhouseStore.cleanBrewhouse(nextState);
    }

    if (nextState.orderVolume > 0) {
        // enter here means that is a new or change order with volume that need to calculate the new batchs
        nextState.order = BrewhouseStore.recalculateBrewhouseBatchs(merge(nextState.order, {
            volume: ContentUtils.getNumber(nextState.orderVolume),
            brewDate: DateUtils.toDateText(nextState.brewDate),
            filtrationDate: DateUtils.toDateText(nextState.filtrationDate),
            orderDate: DateUtils.toDateText(nextState.orderDate),
            isSingle: false,
            isNewModal: nextState.isNewModal
        }), offsetDays, true, nextState.styleBeerSelected, DashboardModalStore.getCurrentLayout());
        // enter here to sync calculated batch from order to outside batch from state
        nextState.batchs = nextState.order.batchs;
        return nextState;
    }

    if (nextState.isNewModal && !nextState.orderVolume) {
        // enter here is a new order that should not have batchs
        return BrewhouseStore.cleanBrewhouse(nextState, []); // default empty array in order to still show the brewing tab
    }

    if (!nextState.isNewModal && get(nextState, 'order.batchs.length') > 0) {
        // enter here means that is a change order that need to recalculate the batchs
        nextState = _sinchronizedInnerOuterOrderDates(nextState);
        nextState.order = BrewhouseStore.recalculateBrewhouseBatchs(nextState.order, offsetDays, true, nextState.styleBeerSelected, DashboardModalStore.getCurrentLayout());
        return nextState;
    }

    if (!nextState.isNewModal && !get(nextState, 'order.batchs.length')) {
        // enter here means that is a change order that dont have batchs
        return BrewhouseStore.cleanBrewhouse(nextState, []); // default empty array in order to still show the brewing tab
    }

    return nextState;
}

function _updateVolume(nextState, newVolume) {
    if (newVolume === undefined) {
        newVolume = _getMinorVolumeOfCurrentTanksSelected(nextState);
    } else if (NumberUtils.containSomeNotNumber(newVolume)) {
        nextState = set(nextState, 'messagesError.volumenTankMessageError', t('dashboard_modal_general_volume_inline_error_must_be_number'));
        nextState.orderVolume = newVolume;
        return nextState;
    } else {
        nextState = set(nextState, 'messagesError.volumenTankMessageError', '');
    }

    nextState.orderVolume = ContentUtils.getNumber(newVolume);
    if (!nextState.orderVolume) { // could be --> 0 || null || undefined
        nextState = set(nextState, 'order.volume', 0);
        nextState.orderVolume = 0;
    } else {
        nextState = set(nextState, 'order.volume', nextState.orderVolume);
    }

    return nextState;
}

function _getMinorVolumeOfCurrentTanksSelected(nextState) {
    return min([
        +get(nextState, 'briteTankSelected.tankObj.volume', 0),
        +get(nextState, 'fermenterTankSelected.tankObj.volume', 0)
    ]);
}

function _recalculeteDateTask(tasks, fromDate, toDate) {
    if (get(tasks, 'length') > 0) {

        const filteredTasks = filter(tasks, task => DateUtils.isDateBetween(task.date, fromDate, toDate));
        return filteredTasks;
    }
    return tasks;
}

function _recalculateFermenterTankByVolume(state) {
    const tankVolume = ContentUtils.getNumber(get(state, 'fermenterTankSelected.volume'), ContentUtils.getNumber(get(state, 'fermenterTankSelected.tankObj.volume')));
    if (state.fermenterTankSelected && tankVolume < state.orderVolume) {
        let nextState = cloneDeep(state);
        // enter here means that the current brite tank dont have volume required, so se need to another brite tank to use it.
        const fermenterTankFit = TankStore.getNextFermenterTankAvailable(nextState.brewDate, nextState.filtrationDate, get(nextState, 'orderId', get(nextState, 'order.id')), nextState.orderVolume, state.currentLayout);

        if (fermenterTankFit) {
            nextState.fermenterTankSelected = fermenterTankFit;
        } else {
            nextState.fermenterTankSelected = null;
        }
        return nextState;
    }
    return state;
}

function _recalculateBriteTankByVolume(state) {
    const tankVolume = ContentUtils.getNumber(get(state, 'briteTankSelected.volume'), ContentUtils.getNumber(get(state, 'briteTankSelected.tankObj.volume')));
    const orderVolume = ContentUtils.getNumber(state.orderVolume);

    if (state.briteTankSelected && tankVolume < orderVolume) {
        let nextState = cloneDeep(state);
        // enter here means that the current brite tank dont have volume required, so se need to another brite tank to use it.
        const briteTankFit = TankStore.getNextBriteTankAvailable(nextState.filtrationDate, nextState.orderDate, get(nextState, 'orderId', get(nextState, 'order.id')), ContentUtils.getNumber(nextState.orderVolume), state.currentLayout);

        if (briteTankFit) {
            nextState.briteTankSelected = briteTankFit;
        } else {
            nextState.briteTankSelected = null;
        }
        return nextState;
    }
    return state;
}

/**
 * Reset all state of the modal.
 * @argument {HTMLElement} self the context that was invoke
 * @private
 */
function cleanModal(self) {
    self.setState({
        order: null,
        dataClicked: null,
        fermenterTasks: [],
        packagingTasks: [],
        brewingTasks: [],
        batchs: [],
        isSuggested: false,
        brewDateMessageError: null,
        filtrationDateMessageError: null,
        orderDateMessageError: null,
        styleBeerSelected: null,
        briteTankSelected: null,
        fermenterTankSelected: null,
        filtrationDate: null,
        brewDate: null,
        orderDate: null,
        styleBeerMessageError: null,
        briteTankMessageError: null,
        fermenterTankMessageError: null,
        isSingleMode: false,
        isBHAllowed: true,
        isFVAllowed: true,
        isBTAllowed: true,
        currentSection: null
    });
}

function onChangeProcess(prevState, oldProcessOrder, newProcessOrder, tasks) {
    const existingOrderProcess = find(oldProcessOrder, processOrder => DashboardModalUtils.isSameProcessAndTask(processOrder, newProcessOrder));
    const otherBrewProcess = filter(oldProcessOrder, processOrder => !DashboardModalUtils.isSameProcessAndTask(processOrder, newProcessOrder)) || [];

    if (existingOrderProcess) {
        newProcessOrder = merge(existingOrderProcess, newProcessOrder);
    }

    const taskFieldName = get(newProcessOrder, 'isSingle') ? getTaskFieldNameByProcessFromSingle(newProcessOrder) : getTaskFieldNameByProcess(newProcessOrder);

    const updatedOrder = prevState.order;

    if (get(newProcessOrder, 'isDeletingOperation')) {
        updatedOrder[taskFieldName] = DashboardModalUtils.removeProcessFromTasks(tasks, newProcessOrder);
        return {
            order: updatedOrder
        };
    }

    otherBrewProcess.push(newProcessOrder);
    const updatedTasks = updateTasksWithProcess(tasks, newProcessOrder);
    updatedOrder[taskFieldName] = updatedTasks;

    return {
        [taskFieldName]: updatedTasks,
        order: updatedOrder
    };
}

function updateTasksWithProcess(tasks, newProcessOrder) {
    let taskTarget = DashboardModalUtils.findTaskFromGivenProcess(tasks, newProcessOrder);
    if (taskTarget === undefined) {
        const sectionType = getSectionType(newProcessOrder);
        taskTarget = createNonIconTask(getTaskFromTaskId(newProcessOrder), sectionType);
    }
    const taskTargetUpdated = DashboardModalUtils.updateProcessFromTask(taskTarget, newProcessOrder);
    return DashboardModalUtils.updateTask(tasks, taskTargetUpdated);
}

function updateStateTask(state, newTask) {
    let updatedTasks;
    let taskFieldName = get(ContentUtils.getTankTypeConfiguration(newTask.tankType || newTask.sectionType), 'tasksFieldName');

    if (!taskFieldName && isSingleTankFromBrewingSection(state)) {
        // enter here where you create a single in brewing section, so
        // which means there should not have any `batchs` field.
        taskFieldName = 'singleTasks';

        const existingTasks = get(state, taskFieldName) || [];
        if (existTask(existingTasks, newTask)) {
            updatedTasks = DashboardModalUtils.updateTask(existingTasks, newTask);
        } else {
            const newNonIconTask = createNonIconTask(newTask.date, state.currentSection, newTask.description, newTask.label);
            existingTasks.push(newNonIconTask);
            updatedTasks = existingTasks;
        }

    } else if (isSingle(state)) {
        taskFieldName = newTask.sectionType === 'BREWHOUSE_TASK' ? 'batchs' : 'singleTasks';
        const existingTasks = get(state, taskFieldName) || [];
        if (existTask(existingTasks, newTask)) {
            updatedTasks = DashboardModalUtils.updateTask(existingTasks, newTask);
        } else {
            const newNonIconTask = createNonIconTask(newTask.date, state.currentSection, newTask.description, newTask.label);
            existingTasks.push(newNonIconTask);
            updatedTasks = existingTasks;
        }
    } else {
        // enter here in combined orders
        const existingTasks = get(state, taskFieldName) || [];
        updatedTasks = DashboardModalUtils.updateTask(existingTasks, newTask);
        state[taskFieldName] = updatedTasks;
        state.order[taskFieldName] = updatedTasks;
    }

    return {
        [taskFieldName]: updatedTasks,
        order: state.order
    };
}

function existTask(tasks, task) {
    return some(tasks, taskValidate => taskValidate.date === task.date && task.sectionType === taskValidate.sectionType);
}

function createNonIconTask(date, sectionType, description = '', label = '') {
    return {
        date,
        description,
        label,
        sectionType,
        name: 'no-icon',
        tankType: ContentUtils.getTankTypeConfiguration(sectionType).tankType
    };
}

function isSingle(state) {
    return state.singleTank !== undefined;
}

function isSingleTankFromBrewingSection(state) {
    return get(state, 'singleTank.type') === 'BH';
}

function getTaskFieldNameByProcess(process) {
    const { isPackagingProcess, isFermentingProcess } = DashboardModalUtils;
    return isPackagingProcess(process) ? 'packagingTasks' : isFermentingProcess(process) ? 'fermenterTasks' : 'batchs';
}

function getTaskFieldNameByProcessFromSingle(process) {
    const { isPackagingProcess, isFermentingProcess } = DashboardModalUtils;
    return process.processSection === 'BH' ? 'singleTasks' : isPackagingProcess(process) ? 'singleTasks' : isFermentingProcess(process) ? 'singleTasks' : 'batchs';
}

function getTaskFromTaskId(process) {
    if (hasDateFormat(process)) {
        const taskId = process.taskId;
        return taskId.substring(0, taskId.indexOf('_'));
    } else {
        return get(process, 'date');
    }
}

function hasDateFormat(process) {
    return process && process.taskId && process.taskId.indexOf('_') > -1;
}

function getSectionType(process) {
    if (process && process.taskId) {
        const taskId = process.taskId;
        return taskId.indexOf('_') > -1 ? (taskId.substring(taskId.indexOf('_') + 1, taskId.length)) : process.processSection;
    } else if (Array.isArray(process)) {
        return get(process, 'processSection');
    }
}

module.exports = {
    onChangeBrewDate,
    onChangeFiltrationDate,
    onChangePackagingDate,
    onChangeBeerStyle,
    onChangeBriteTank,
    onChangeFermenterTank,
    onChangeTaskType,
    onChangeTask,
    onChangeVolume,
    onChangeVolumeNew,
    onChangeProcess,
    onDeleteTask,
    onChangeBrewTurn,
    onChangeBrewTurnNew,
    getExistingModalState,
    formatBatchs,
    getNewModalState,
    isValidForm,
    hydratedTasksWithProducts: _hydratedTasksWithProducts,
    initializePackagingTask,
    initializeFermentingTask,
    someProductAlreadyConfirmed: _someProductAlreadyConfirmed,
    initializeBrewingTurns,
    cleanModal,
    updateStateTask,
    openNewBrewOrder,
    openExistingBrewOrder
};



/** WEBPACK FOOTER **
 ** ./src/stores/DashboardModalStore/DashboardModalBrewStore/DashboardModalBrewStore.js
 **/